export const skipToNextDynamicBlock = () => {
    const blocks = Array.from(document.querySelectorAll<HTMLElement>('[data-dynamic-block]'));

    const active = document.activeElement;
    if (!(active instanceof HTMLElement)) return;

    const currentBlock = active.closest<HTMLElement>('[data-dynamic-block]');
    if (!currentBlock) return;

    const currentIndex = blocks.indexOf(currentBlock);
    const nextBlock = blocks[currentIndex + 1];

    nextBlock?.focus();
};
